import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

function randInt(min, max, excludeZero = false) {
  let value;
  do {
    value = Math.floor(Math.random() * (max - min + 1)) + min;
  } while (excludeZero && value === 0);
  return value;
}

function formatLinearLatex(a, b) {
  const aPart = a === 1 ? "" : a === -1 ? "-" : String(a);
  const bPart = b === 0 ? "" : b > 0 ? ` + ${b}` : ` - ${Math.abs(b)}`;
  return `${aPart}x${bPart}`;
}

export function generateTask(options = {}) {
  const a = randInt(-6, 6, true);
  const b = randInt(-10, 10);
  const answer = randInt(-7, 7);
  const targetValue = a * answer + b;

  return {
    type: "LinearArgumentForValueTask",
    data: {
      a,
      b,
      targetValue,
      answer,
      mentionLinearFunction: options.mentionLinearFunction !== false,
    },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginTop: 6 }}>
      <div>
        Dana jest {data.mentionLinearFunction !== false ? "funkcja liniowa" : "funkcja"}:
      </div>
      <BlockMath math={`f(x)=${formatLinearLatex(data.a, data.b)}`} />
      <div>
        Dla jakiego argumentu funkcja przyjmuje wartość{" "}
        <InlineMath math={`${data.targetValue}`} />?
      </div>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <div style={{ marginTop: 10 }}>
      <InlineMath math="x=" />
      <FractionInput
        value={userAnswer || ""}
        onChange={onChange}
        disabled={disabled}
        label={"x"}
      />
    </div>
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const parsed = userAnswer.parsed;
  if (parsed == null || isNaN(parsed)) return false;
  return Math.abs(parsed - data.answer) < 0.001;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`x=${data.answer}`} />;
}

export function renderExplanation({ data }) {
  const rightSide = data.targetValue - data.b;

  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <div>
        Szukamy argumentu <InlineMath math="x" />, dla którego{" "}
        <InlineMath math={`f(x)=${data.targetValue}`} />.
      </div>
      <div style={{ marginTop: 8 }}><strong>Krok 1.</strong> Układamy równanie:</div>
      <BlockMath math={`${formatLinearLatex(data.a, data.b)}=${data.targetValue}`} />
      <div><strong>Krok 2.</strong> Przenosimy wyraz wolny:</div>
      <BlockMath math={`${data.a}x=${rightSide}`} />
      <div>
        <strong>Krok 3.</strong> Dzielimy obie strony przez{" "}
        <InlineMath math={`${data.a}`} />:
      </div>
      <BlockMath math={`x=\\frac{${rightSide}}{${data.a}}=${data.answer}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer?.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`x=${userAnswer.raw}`} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
